import ZendeskAPI from '../zendesk-api'

export const getHelpCenterArticle = async (articleId) => {
  return await ZendeskAPI.get(`/help_center/articles/${articleId}`)
}
